import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "profile-unit grid grid-cols-1 gap-y-2" }
const _hoisted_2 = {
  class: "link-box",
  href: "/pdf/podminky-uzivani.pdf",
  target: "_blank"
}
const _hoisted_3 = {
  class: "link-box",
  href: "/pdf/pravidla-souteze.pdf",
  target: "_blank"
}
const _hoisted_4 = {
  class: "link-box",
  href: "/ochrana-osobnich-udaju"
}
const _hoisted_5 = {
  class: "link-box",
  href: "https://www.cezdistribuce.cz/cs/prokop-divis",
  target: "_blank"
}

import {ArrowDownTrayIcon, DocumentTextIcon, GlobeAltIcon} from "@heroicons/vue/24/outline";
import {i18n} from "@/services/support/i18n";

export default /*@__PURE__*/_defineComponent({
  __name: 'ProfileInfoLinks',
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("a", _hoisted_2, [
      _createVNode(_unref(ArrowDownTrayIcon), { class: "h-5 w-5 text-cez-color" }),
      _createElementVNode("span", null, _toDisplayString(_unref(i18n).termsAndConditions), 1)
    ]),
    _createElementVNode("a", _hoisted_3, [
      _createVNode(_unref(ArrowDownTrayIcon), { class: "h-5 w-5 text-cez-color" }),
      _createElementVNode("span", null, _toDisplayString(_unref(i18n).competitionRules), 1)
    ]),
    _createElementVNode("a", _hoisted_4, [
      _createVNode(_unref(DocumentTextIcon), {
        class: "h-5 w-5 text-cez-color",
        "aria-hidden": "true"
      }),
      _createElementVNode("span", null, _toDisplayString(_unref(i18n).privacyPolicy), 1)
    ]),
    _createElementVNode("a", _hoisted_5, [
      _createVNode(_unref(GlobeAltIcon), {
        class: "h-5 w-5 text-cez-color",
        "aria-hidden": "true"
      }),
      _createElementVNode("span", null, _toDisplayString(_unref(i18n).contactCez), 1)
    ])
  ]))
}
}

})